import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Home() {
  const [isVisible, setIsVisible] = useState(false);
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: 'Tamir',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  useEffect(() => {
    setIsVisible(true);
    
    // Add Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "3D Print Pro",
      "description": "Ankara'da profesyonel 3D yazıcı tamir, bakım ve kurulum hizmetleri",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "telephone": "+905414565635",
      "email": "info@3dprinterservis.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3",
        "addressLocality": "Yenimahalle",
        "addressRegion": "Ankara",
        "postalCode": "06480",
        "addressCountry": "TR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "39.9334",
        "longitude": "32.8597"
      },
      "openingHours": "Mo-Fr 09:00-18:00",
      "priceRange": "$$",
      "serviceArea": {
        "@type": "City",
        "name": "Ankara"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "3D Yazıcı Hizmetleri",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "3D Yazıcı Tamiri",
              "description": "Arızalı 3D yazıcılarınızı orijinal performansına kavuşturuyoruz"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Bakım ve Servis",
              "description": "Düzenli bakım ile cihazlarınızın ömrünü uzatıyoruz"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Kurulum ve Kalibrasyon",
              "description": "Yeni 3D yazıcılarınızın profesyonel kurulumu ve hassas kalibrasyonu"
            }
          }
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('service', formData.service);
      formDataToSend.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d3jmprnuouli8ar1pd60', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', service: 'Tamir', message: '' });
        setTimeout(() => {
          setShowAppointmentModal(false);
          setSubmitStatus('');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-12 w-auto"
                />
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-gray-900 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  ANASAYFA
                </Link>
                <Link to="/hizmetler" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HİZMETLERİMİZ
                </Link>
                <Link to="/markalar" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  MARKALAR
                </Link>
                <Link to="/hakkimizda" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HAKKIMIZDA
                </Link>
                <Link to="/iletisim" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  İLETİŞİM
                </Link>
                <a 
                  href="https://3dprinterankara.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  SATIŞ
                </a>
                <button 
                  onClick={() => setShowAppointmentModal(true)}
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  RANDEVU AL
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/46918bc6f387c2d55e13199205cb304d.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className={`text-center max-w-4xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1 className="text-6xl md:text-7xl font-bold text-white mb-8 leading-tight">
              3D Printer Ankara
              <span className="text-red-500 block">Bakım Servisi</span>
            </h1>
            <p className="text-2xl text-white/90 mb-10 leading-relaxed max-w-3xl mx-auto">
              Profesyonel 3D yazıcı tamir, bakım ve kurulum hizmetleri. 
              Uzman ekibimizle cihazlarınızı en iyi durumda tutuyoruz.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <button 
                onClick={() => setShowAppointmentModal(true)}
                className="bg-red-600 hover:bg-red-700 text-white px-10 py-5 rounded-xl text-xl font-bold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-2xl"
              >
                Ücretsiz Teklif Al
              </button>
              <Link 
                to="/hizmetler"
                className="border-3 border-white text-white hover:bg-white hover:text-red-600 px-10 py-5 rounded-xl text-xl font-bold transition-all duration-300 whitespace-nowrap cursor-pointer text-center shadow-2xl"
              >
                Hizmetlerimizi İncele
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className={`text-center mb-16 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Hizmetlerimiz</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              3D yazıcı teknolojisinde uzman ekibimizle, cihazlarınızın her türlü ihtiyacını karşılıyoruz
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: "3D Yazıcı Tamiri",
                description: "Arızalı 3D yazıcılarınızı orijinal performansına kavuşturuyoruz. Hızlı teşhis ve kaliteli tamir hizmeti.",
                icon: "ri-tools-line",
                image: "https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/b05aab71d005e9d218d89af78ebd609d.jfif",
                link: "/hizmetler/tamir"
              },
              {
                title: "Bakım ve Servis",
                description: "Düzenli bakım ile cihazlarınızın ömrünü uzatıyoruz. Preventif bakım programları mevcuttur.",
                icon: "ri-settings-3-line",
                image: "https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/5e779f6347ea92dbf7031863dd05ade1.jfif",
                link: "/hizmetler/bakim"
              },
              {
                title: "Kurulum ve Kalibrasyon",
                description: "Yeni 3D yazıcılarınızın profesyonel kurulumu ve hassas kalibrasyonu için uzman desteği.",
                icon: "ri-compass-3-line",
                image: "https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/547b4ba6a78f8cb186d8f94bb9986b88.jfif",
                link: "/hizmetler/kurulum"
              }
            ].map((service, index) => (
              <div 
                key={index}
                className={`bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-500 hover:-translate-y-2 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${300 + index * 100}ms` }}
              >
                <div className="h-48 bg-gray-200 overflow-hidden">
                  <img 
                    src={service.title === "3D Yazıcı Tamiri" ? service.image : service.title === "Bakım ve Servis" ? service.image : service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                    <i className={`${service.icon} text-2xl text-red-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <Link 
                    to={service.link}
                    className="text-red-600 hover:text-red-700 font-medium transition-colors cursor-pointer"
                  >
                    Detayları Gör →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className={`transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Neden Bizi Tercih Etmelisiniz?
              </h2>
              <div className="space-y-6">
                {[
                  {
                    title: "Uzman Ekip",
                    description: "3D yazıcı teknolojisinde deneyimli ve sertifikalı teknisyenlerimiz"
                  },
                  {
                    title: "Hızlı Servis",
                    description: "Ankara genelinde hızlı müdahale ve kısa sürede çözüm"
                  },
                  {
                    title: "Kaliteli Yedek Parça",
                    description: "Orijinal ve kaliteli yedek parçalar ile uzun ömürlü tamir"
                  },
                  {
                    title: "Uygun Fiyat",
                    description: "Rekabetçi fiyatlarla profesyonel hizmet kalitesi"
                  }
                ].map((item, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-6 h-6 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">{item.title}</h3>
                      <p className="text-gray-600">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className={`transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%203D%20printer%20technician%20working%20on%20advanced%203D%20printing%20equipment%20in%20modern%20workshop%2C%20technical%20expertise%20demonstration%2C%20clean%20corporate%20environment%2C%20red%20and%20white%20branding%20elements%2C%20high-tech%20repair%20station%2C%20precision%20tools%20and%20components&width=600&height=500&seq=why-choose-us&orientation=landscape"
                alt="Profesyonel 3D Yazıcı Servisi"
                className="w-full rounded-xl shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* SEO Content Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className={`text-center transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
              Ankara'da 3D Yazıcı Tamir ve Bakım Hizmetleri
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 text-left">
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-tools-fill text-2xl text-red-600"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-3">3D Yazıcı Tamir Ankara</h3>
                <p className="text-gray-600 text-sm">
                  Ankara'da 3D yazıcı tamiri konusunda uzman ekibimizle, tüm marka ve modellerde profesyonel tamir hizmeti sunuyoruz.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-settings-3-fill text-2xl text-red-600"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-3">3D Printer Kurulum</h3>
                <p className="text-gray-600 text-sm">
                  Yeni aldığınız 3D yazıcıların profesyonel kurulumu ve kalibrasyonu için deneyimli teknisyen desteği.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-customer-service-2-fill text-2xl text-red-600"></i>
                </div>
                <h3 className="font-semibold text-gray-900 mb-3">Bakım Servisi</h3>
                <p className="text-gray-600 text-sm">
                  Düzenli bakım programları ile 3D yazıcılarınızın performansını maksimum seviyede tutuyoruz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Hakkımızda</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Ankara'da 3D yazıcı teknolojisi alanında öncü firmayız
            </p>
          </div>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%203D%20printing%20workshop%20in%20Ankara%20with%20professional%20equipment%2C%20clean%20corporate%20environment%2C%20technical%20team%20working%20on%20various%203D%20printers%2C%20red%20and%20white%20corporate%20branding%2C%20high-tech%20facility%20interior%2C%20precision%20manufacturing%20setup&width=600&height=400&seq=about-us&orientation=landscape"
                alt="3D Print Pro Ekibi"
                className="w-full rounded-xl shadow-lg object-cover object-top"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Ankara'nın Güvenilir 3D Yazıcı Servisi
              </h3>
              <p className="text-gray-600 mb-6">
                2015 yılından beri Ankara'da 3D yazıcı tamir, bakım ve kurulum hizmetleri sunuyoruz. 
                Uzman ekibimiz ve modern donanımımızla, tüm marka ve modellerde profesyonel hizmet veriyoruz.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600 mb-2">500+</div>
                  <div className="text-gray-600">Tamir Edilen Cihaz</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600 mb-2">8+</div>
                  <div className="text-gray-600">Yıllık Deneyim</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">İletişim</h2>
            <p className="text-xl text-gray-600">
              3D yazıcı sorunlarınız için hemen iletişime geçin
            </p>
          </div>
          <div className="grid lg:grid-cols-2 gap-12">
            <div>
              <div className="space-y-8">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                    <i className="ri-map-pin-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Adres</h3>
                    <p className="text-gray-600">
                      1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3<br />
                      06480 Yenimahalle/Ankara
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                    <i className="ri-phone-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Telefon</h3>
                    <p className="text-gray-600">0541 456 56 35</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                    <i className="ri-mail-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">E-posta</h3>
                    <p className="text-gray-600">info@3dprinterservis.com</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Hızlı İletişim</h3>
              <div className="space-y-4">
                <button 
                  onClick={() => setShowAppointmentModal(true)}
                  className="w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer"
                >
                  Randevu Al
                </button>
                <a 
                  href="https://wa.me/905414565635"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white py-3 rounded-lg font-medium transition-colors cursor-pointer block text-center"
                >
                  WhatsApp ile İletişim
                </a>
                <a 
                  href="tel:05414565635"
                  className="w-full border-2 border-gray-300 text-gray-700 hover:bg-gray-50 py-3 rounded-lg font-medium transition-colors cursor-pointer block text-center"
                >
                  Telefon ile Ara
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-10 w-auto"
                />
              </h3>
              <p className="text-gray-400">
                Ankara'da 3D yazıcı tamir, bakım ve kurulum hizmetlerinde uzman ekip.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Hizmetler</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hizmetler/tamir" className="hover:text-white transition-colors">3D Yazıcı Tamiri</Link></li>
                <li><Link to="/hizmetler/bakim" className="hover:text-white transition-colors">Bakım Servisi</Link></li>
                <li><Link to="/hizmetler/kurulum" className="hover:text-white transition-colors">Kurulum</Link></li>
                <li><Link to="/hizmetler" className="hover:text-white transition-colors">Tüm Hizmetler</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Şirket</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hakkimizda" className="hover:text-white transition-colors">Hakkımızda</Link></li>
                <li><Link to="/iletisim" className="hover:text-white transition-colors">İletişim</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">İletişim</h4>
              <div className="space-y-2 text-gray-400">
                <p>1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3, 06480 Yenimahalle/Ankara</p>
                <p>0541 456 56 35</p>
                <p>info@3dprinterservis.com</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 3D Print Pro. Tüm hakları saklıdır. | 
              <a href="https://cdco.com.tr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors ml-1">
                Bu web tasarımı CDCO tarafından tasarlanmıştır
              </a>
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Float Button */}
      <a
        href="https://wa.me/903123945635"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>

      {/* Appointment Modal */}
      {showAppointmentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900">Randevu Al</h3>
                <button 
                  onClick={() => setShowAppointmentModal(false)}
                  className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              
              {submitStatus === 'success' && (
                <div className="mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                  Randevunuz başarıyla oluşturuldu! En kısa sürede size dönüş yapacağız.
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                  Bir hata oluştu. Lütfen tekrar deneyin.
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form id="randevu-form">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Ad Soyad *
                  </label>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="Adınızı ve soyadınızı girin"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    E-posta *
                  </label>
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="E-posta adresinizi girin"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Telefon *
                  </label>
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="Telefon numaranızı girin"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Hizmet Türü
                  </label>
                  <select 
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent pr-8 text-sm"
                  >
                    <option value="Tamir">Tamir</option>
                    <option value="Bakım">Bakım</option>
                    <option value="Kurulum">Kurulum</option>
                    <option value="Diğer">Diğer</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Mesaj
                  </label>
                  <textarea 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
                    placeholder="Sorunuz veya mesajınızı yazın (maksimum 500 karakter)"
                  ></textarea>
                  <div className="text-xs text-gray-500 mt-1">
                    {formData.message.length}/500 karakter
                  </div>
                </div>
                <button 
                  type="submit"
                  disabled={isSubmitting || formData.message.length > 500}
                  className="w-full bg-red-600 hover:bg-red-700 disabled:bg-gray-400 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer"
                >
                  {isSubmitting ? 'Gönderiliyor...' : 'Randevu Oluştur'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
